/**
 * Controller: RemoveCouponModal
 */
angular.module('acme.view.application.coupons.list.removeCoupon.controllers', [
  'ui.router',
  'acme.common.service.api'])
.controller('CouponRemoveModalController', [ '$scope', '$uibModalInstance', 'currentCoupon', function($scope, $uibModalInstance, currentCoupon) {

    $scope.errors = [];

    $scope.model = {
      name: currentCoupon.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(currentCoupon);
    };

    $scope.init();

}]);